module.exports = "https://www.gc-pro.gnp.com.mx/c8aa9ff959eb3682bb8985734f93b83b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-cards-active.svg
// module id = 1822
// module chunks = 0